module.exports = __webpack_public_path__ + "static/img/jusang_icon.67bac0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/jusang_icon.png
// module id = 8pN3
// module chunks = 1